import { jsx } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import StarActive from "../../../assets/svg/star-active.ff581781.svg";
import StarDefault from "../../../assets/svg/star-default.2456191b.svg";
import StarHover from "../../../assets/svg/star-hover.46670427.svg";
import '../../../assets/index25.css';const rate = "_rate_1f4w8_1";
const star = "_star_1f4w8_7";
const active = "_active_1f4w8_27";
const svg = "_svg_1f4w8_40";
const s = {
  rate,
  star,
  active,
  svg
};
const RateStar = ({ active: active2 = false, hovered = false, ...rest }) => {
  return /* @__PURE__ */ jsx("button", { ...rest, className: clsx(s.star, { [s.active]: active2 }), children: hovered ? /* @__PURE__ */ jsx("img", { src: StarHover, alt: "star", className: s.svg }) : active2 ? /* @__PURE__ */ jsx("img", { src: StarActive, alt: "star", className: s.svg }) : /* @__PURE__ */ jsx("img", { src: StarDefault, alt: "star", className: s.svg }) });
};
const STAR_DIGITS = [1, 2, 3, 4, 5];
const Rate = withThemeAndSize(
  forwardRef(({ rateValue = 0, className, onRate, ...rest }, ref) => {
    const [hoveredNumber, setHoveredNumber] = useState(0);
    const resetHover = () => setHoveredNumber(0);
    return /* @__PURE__ */ jsx("div", { ...rest, ref, className: clsx(s.rate, className), children: STAR_DIGITS.map((v) => /* @__PURE__ */ jsx(
      RateStar,
      {
        active: rateValue >= v,
        hovered: hoveredNumber > v - 1,
        onMouseEnter: () => setHoveredNumber(v),
        onMouseLeave: resetHover,
        onClick: () => onRate == null ? void 0 : onRate(v)
      },
      v
    )) });
  })
);
export {
  Rate
};
